import React from "react";
import "./Style.scss";
import errorImg from "../../Assets/Images/noPage.svg";

const ErrorPage = () => {
  return (
    <div className="error-container">
      <div className="error-content">
        <img src={errorImg} alt="Error Illustration" className="error-image" />
        <div className="error-text">
          <h1 className="error-code">404</h1>
          <p className="error-message">Oops! Page not found.</p>
          <a href="/" className="home-link">
            Go Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
